import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButton } from '@xingternal/button';

import { EditButton, usePageContext } from '@xingternal/pages-common';

import styles from './PageInfo.css';

const PageInfoButton = ({ isLabel = false }: { isLabel?: boolean }) => {
  const { pageContext } = usePageContext();
  const pageSlug = pageContext?.pageSlug;
  return isLabel ? (
    <TextButton
      to={`${pageContext?.basePath}/${pageSlug}/edit/pageInfo`}
      size={'small'}
      noMargin
      className={styles.editLabel}
      data-testid={'EDIT_BUTTON_ON_EMPTY_SLOGAN'}
    >
      <FormattedMessage
        id={'EP_SLOGAN_EDIT_HINT'}
        defaultMessage={'EP_SLOGAN_EDIT_HINT'}
      />
    </TextButton>
  ) : (
    <EditButton
      size={'small'}
      showIcon
      className={styles.editSloganButton}
      data-cy="EDIT_BUTTON_ON_SLOGAN"
      data-testid="EDIT_BUTTON_ON_SLOGAN"
      to={`${pageContext?.basePath}/${pageSlug}/edit/pageInfo`}
    />
  );
};

export default PageInfoButton;
